import { IonButton, IonIcon, IonImg } from '@ionic/react';
import React, { useEffect, useRef, useState } from 'react';
import SlidingPanel from 'react-sliding-side-panel';
import 'react-sliding-side-panel/lib/index.css';
import QuicksightQ from './QuicksightQ';
import { useAppSelector } from '../../Hooks';
import { selectUser } from '../../reducers/UserReducer';
import { isStaff } from '../../components/extras/Functions';
import HeyAlphaIcon from "../../AE2/static/pics/hey_alpha_icon.png";
import HeyAlphaIconWBubble from "../../AE2/static/pics/hey_alpha_icon_w_bubble.png"
import HeyAlphaIconBubble from "../../AE2/static/pics/hey_alpha_bubble.png";
import HeyAlphaInquisitive from "../../AE2/static/pics/hey_alpha_inquisitive.png";
import { isMobile } from 'react-device-detect';
import CheckRole from '../../components/extras/CheckRole';
import { HEY_ALPHA_TOPIC_ID } from '../../actions/settings';
import useToggle from '../../utils/useToggle';
import { closeCircle } from 'ionicons/icons';


interface HeyAlphaProps {
}


const HeyAlpha: React.FC<HeyAlphaProps> = () => {
    const [openPanel, setOpenPanel] = useState(false);
    const [showBubble, toggle] = useToggle(false);
    const [showCloseBtn, toggleShowCloseBtn] = useToggle(false);
    const [showAlpha, toggleShowAlpha] = useState((localStorage.getItem("HeyAlphaIcon")?.toLowerCase() === 'true'));
    
    const [y, setY] = useState((() => Number(localStorage.getItem("HeyAlphaY")) || 200));
    const dragging = useRef(false);
    const offset = useRef(0);

    
    useEffect(() => {
      localStorage.setItem("HeyAlphaY", String(y));
    }, [y]);
    useEffect(() => {
      localStorage.setItem("HeyAlphaIcon", String(showAlpha));
    }, [showAlpha]);


    const handleMouseDown = (e:any) => {
      dragging.current = true;
      offset.current = e.clientY - y;
      document.addEventListener("mouseup", handleMouseUp);
      document.addEventListener("mousemove", handleMouseMove);

    };

    const handleMouseMove = (e:any) => {
      if (!dragging.current) return;

      const newY = e.clientY - offset.current;
      const maxY = window.innerHeight - 60;

      const clampedY = Math.max(0, Math.min(newY, maxY));

      setY(clampedY);
    };

    const handleMouseUp = () => {
      dragging.current = false;

      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };


    const user = useAppSelector(selectUser);

    if (user.first_name !== "" && !isStaff(user) && !CheckRole(user,['Admin','Supervisor'])) {
        return null;
      }



    return (
      <div className=" heyAlphaContainer">
        <div onMouseEnter={()=>toggleShowCloseBtn()} onMouseLeave={()=>toggleShowCloseBtn()}>

        {!showAlpha ?
          <div className='closedAlpha center-all' 
            onClick={()=> toggleShowAlpha(!showAlpha)}
            style={{top:y}}
            onMouseDown={handleMouseDown}
            > 
            <IonImg className='closedAlphaIcon' src={HeyAlphaIcon}></IonImg>
          </div>
        :
        <>
        <div style={{position:'relative'}}>
        <IonButton hidden={!showCloseBtn} 
          fill='clear' mode='md' color={'danger'} 
          
          onClick={(e)=> {e.preventDefault();toggleShowAlpha(!showAlpha);}} 
          
          className='HeyAlphaCloseBtn'>
          <IonIcon src={closeCircle}/>
        </IonButton>
        </div>
        <IonImg hidden={!showBubble} src={HeyAlphaIconBubble} className="HeyAlphaBubble" ></IonImg>
          <IonButton onClick={() => setOpenPanel(true)} fill="clear" mode='md' > 
            {isMobile ?
            <IonImg src={HeyAlphaIconWBubble} className="HeyAlphaIcon"></IonImg>
            :
            <IonImg src={HeyAlphaIcon} className="HeyAlphaIcon" onMouseEnter={()=>toggle()} onMouseLeave={()=>toggle()}></IonImg>
            }
          </IonButton></>
        }

        </div>
        <SlidingPanel
          type={"right"}
          isOpen={openPanel}
          size={isMobile ? 100 : 60}
          backdropClicked={() => setOpenPanel(false)}
        >
          {/* <div style={{backgroundColor:'#0aa6e9c5',height:'100%'}}> */}
          <div style={{ backgroundColor: "#0A2533", height: "100%",}}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                height:'7.5%'
              }}
            >
              <h3>
                <IonImg
                  src={HeyAlphaInquisitive}
                  style={
                    isMobile
                      ? { height: "9vw", marginLeft: "1rem" }
                      : { height: "3vw", marginLeft: "2rem" }
                  }
                ></IonImg>
              </h3>
              <div className="center-all" style={{ maxWidth: "50px" }}>
                <IonButton color={"danger"} mode='md' onClick={() => setOpenPanel(false)}>
                  X
                </IonButton>
              </div>
            </div>
            <QuicksightQ topicId={HEY_ALPHA_TOPIC_ID} />
          </div>
        </SlidingPanel>
      </div>
    );
};

export default HeyAlpha;
